export default "__VITE_ASSET__Bxj3pnvS__"